import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Heading } from '@shopify/polaris';
import { ta } from 'utils';

const propTypes = {
  forForm: PropTypes.bool, // Show view headers else for form
}

const defaultProps = {
  forForm: false
}

const TransferItemHeaders = ({ forForm, ...props }) => {
  return (
    <div className="row mb20">
      <div className={ forForm ? "col-sm-4 " : "col-sm-3 col-xl-3" }>
        <Heading>
          { I18n.t("activerecord.models.product.one") }
        </Heading>
      </div>

      {/* For form (new form) */}
      { forForm ?
        <React.Fragment>
          <div className="col-sm-2">
            <Heading>
              { ta("general.quantity")  }
            </Heading>
          </div>
          
          <div className="col-md-2">
            <Heading>
              { ta("products_transfer.unit_cost") }
            </Heading>
          </div>
          
          <div className="col-md-1">
            <Heading>
              { ta("products_transfer.tax_rate") }
            </Heading>
          </div>
          
          <div className="col-sm-3">
            <Heading>
              { ta("products_transfer.unit_cost_with_tax") }
            </Heading>
          </div>
        </React.Fragment>
      :
        <React.Fragment>
          {/* =================== Show  headers =================== */}
          <div className="col-sm-1">
            <Heading>
              { ta("transfer.total_shipped")}
            </Heading>
          </div>
          
          <div className="col-sm-1">
            <Heading>
              { ta("transfer.total_sold") }
            </Heading>
          </div>
          
          <div className="col-sm-2">
            <Heading>
              { ta("products_transfer.unit_cost") }
            </Heading>
          </div>

          <div className="col-sm-2">
            <Heading>
              { ta("products_transfer.total_amount") }
            </Heading>
          </div>

          <div className="col-sm-1">
            <Heading>
              { ta("products_transfer.tax_rate") }
            </Heading>
          </div>

          <div className="col-sm-2">
            <Heading>
              { ta("products_transfer.total_amount_with_tax") }
            </Heading>
          </div>
        </React.Fragment>
      }
    </div>
  )
};

TransferItemHeaders.propTypes = propTypes;
TransferItemHeaders.defaultProps = defaultProps;

export default TransferItemHeaders;